import React, { Component } from 'react'
import styled from 'styled-components'
import SearchFilter from '../SearchFilter/SearchFilter'
import spacing from 'utils/spacing'

const Outer = styled.div`
  padding: ${spacing.default}px;
  border-radius: 3px;
  background: white;
  width: 70%;
  margin-bottom: ${spacing.default}px;

  @media screen and (max-width: 1108px) {
    width: 100%;
    padding: 0;
  }
`

class CampaignPageOpportunitiesFilter extends Component {
  render() {
    const { placeholder, onChange } = this.props

    return (
      <Outer>
        <SearchFilter placeholder={placeholder} onChange={onChange} />
      </Outer>
    )
  }
}

export default CampaignPageOpportunitiesFilter
